/**
 * 下拉加载更多产品功能（使用 IntersectionObserver，仅绑定一次）
 */
document.addEventListener('DOMContentLoaded', function () {
  // 避免重复执行
  if (window.__loadMoreInitialized__) return;
  window.__loadMoreInitialized__ = true;

  // 添加旋转动画样式
  if (!document.getElementById('load-more-styles')) {
    const style = document.createElement('style');
    style.id = 'load-more-styles';
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  const container = document.querySelector('.load-more-container[data-section-id]');
  if (!container) return;

  console.log(container, 'container'); // ✅ 只会执行一次

  setupLoadMore(container);

  function setupLoadMore(container) {
    const sectionId = container.dataset.sectionId;
    const productLimit = parseInt(container.dataset.productLimit || '20');
    const productGrid = container.closest('.collection-slider-row')?.querySelector('.product-grid');
    if (!productGrid) return;

    let isLoading = false;
    let hasMore = true;
    let currentPage = 1;

    function getNextPageUrl() {
      const nextPageLink = document.querySelector('.next-page-url');
      if (nextPageLink?.dataset.nextPageUrl) return nextPageLink.dataset.nextPageUrl;

      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      params.set('page', currentPage + 1);
      params.set('limit', productLimit);
      url.search = params.toString();
      return url.toString();
    }

    async function loadMoreProducts() {
      if (isLoading || !hasMore) return;
      isLoading = true;

      const spinner = container.querySelector('.load-more-spinner');
      if (spinner) spinner.style.display = 'flex';

      try {
        const nextPageUrl = getNextPageUrl();
        const response = await fetch(nextPageUrl);
        if (!response.ok) throw new Error('网络响应错误: ' + response.status);

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        let newProducts = doc.querySelectorAll('.product-block');
        if (newProducts.length === 0) {
          const newSection = doc.querySelector(`.section-id-${sectionId}`);
          if (newSection) newProducts = newSection.querySelectorAll('.product-block');
        }
        if (newProducts.length === 0) {
          const newGrid = doc.querySelector('.product-grid');
          if (newGrid) newProducts = newGrid.querySelectorAll('.product-block');
        }

        if (newProducts.length > 0) {
          newProducts.forEach(product => productGrid.appendChild(product.cloneNode(true)));
          currentPage++;

          const newNextPageLink = doc.querySelector('.next-page-url');
          if (newNextPageLink?.dataset.nextPageUrl) {
            const currentNextPageLink = document.querySelector('.next-page-url');
            if (currentNextPageLink) {
              currentNextPageLink.dataset.nextPageUrl = newNextPageLink.dataset.nextPageUrl;
              currentNextPageLink.href = newNextPageLink.dataset.nextPageUrl;
            }
          } else {
            hasMore = false;
            container.style.display = 'none';
            observer.unobserve(container);
          }

          if (newProducts.length < productLimit) {
            hasMore = false;
            container.style.display = 'none';
            observer.unobserve(container);
          }
        } else {
          hasMore = false;
          container.style.display = 'none';
          observer.unobserve(container);
        }
      } catch (error) {
        hasMore = false;
        container.innerHTML = '<div class="text-center">加载失败，请刷新页面重试</div>';
      } finally {
        isLoading = false;
        if (spinner) spinner.style.display = 'none';
      }
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && hasMore && !isLoading) {
          loadMoreProducts();
        }
      });
    }, {
      rootMargin: '300px',
      threshold: 0.01
    });

    observer.observe(container);

    container.addEventListener('click', function () {
      if (!isLoading && hasMore) {
        loadMoreProducts();
      }
    });
  }
});
